// Converted from application/views/sculptures/blue-lady_v.php. Edit this component directly.
export default function SculpturesBlueLadyPage() {
  return <><div class={"firstContainer container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/blue-lady/blue-lady-face.jpg"} alt={"Blue Lady"} />
<figcaption>{"#1"}</figcaption>
</figure>
<div class={"text"}>
<div>
<div class={"mainTitleWrp"}>
<h1>{"Blue Lady"}</h1>
<p>
<b>{"75 x 105 x 120cm"}</b><br />{"\n                    29.4” x 41.3” x 47.2”"}<br />{"\n                    Bronze No. in Series 7\n                "}</p>
</div>
</div>
</div>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<p>{"\n                Ellen, the Swedish girl who modelled for this sculpture was not just a beautiful person in every way but an accomplished dress designer and seamstress.\n            "}</p>
<p>{"\n                In fact, she designed and wore the dress which was cast in bronze as part of this sculpture.\n            "}</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/blue-lady/blue-lady-closeup.jpg"} alt={"Blue Lady closeup"} />
<figcaption>{"#2"}</figcaption></figure>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<p>{"\n                We spent more than a year making the original piece in wax at my studio in Via Luna, Florence.  During that time we shared many stories about Sweden where I had lived for a year, and Florence where she had spent seven years.\n            "}</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/blue-lady/blue-lady-back.jpg"} alt={"Blue Lady Back"} />
<figcaption>{"#3"}</figcaption></figure>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/blue-lady/blue-lady-front.jpg"} alt={"Blue Lady front"} />
<figcaption>{"#4"}</figcaption></figure>
<div class={"text"}>
<div>
<p>{"\n                As one might imagine, as an exotic Scandinavian, Ellen was very popular with the local boys, and had many suitors.\n            "}</p>
</div>
</div>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<p>{"\n                I saw this bunch of rusty keys in Mercato Sant’Ambrogio in Florence, and thought of Ellen, trying to choose with her heart, but feeling at a loss.\n            "}</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/blue-lady/blue-lady-hand.jpg"} alt={"Blue Lady Hand Detail"} />
<figcaption>{"#5"}</figcaption></figure>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/blue-lady/blue-lady-detail.jpg"} alt={"Blue Lady Detail"} />
<figcaption>{"#6"}</figcaption></figure>
<div class={"text"}>
<div>
<p>{"Hence; "}<b>{"“Blue Lady”"}</b></p>
</div>
</div>
</div>
<div class={"container fullPhoto"}>
<figure class={"photo"}>
<img src={"/assets/images/sculptures/blue-lady/blue-lady-full.jpg"} alt={"Blue Lady Face"} />
<figcaption>{"#7"}</figcaption></figure>
</div>
</>;
}
